import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Team from '@/pages/Team'
import WellnessHealth from '@/pages/WellnessHealth'
import MenopauseHealth from '@/pages/MenopauseHealth'
import AcneHealth from '@/pages/AcneHealth'
import TravelHealth from '@/pages/TravelHealth'
import BlogIVMyths from '@/pages/BlogIVMyths'
import ScrollToTop from '@/components/ScrollToTop'
import BrandHead from '@/components/BrandHead'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/team', element: <Team /> },
  { path: '/havenwellnesshealth', element: <WellnessHealth /> },
  { path: '/menopausehealth', element: <MenopauseHealth /> },
  { path: '/acnehealth', element: <AcneHealth /> },
  { path: '/travelhealth', element: <TravelHealth /> },
  { path: '/blog/iv-therapy-myths', element: <BlogIVMyths /> },
]

function App() {
  const element = useRoutes(routes)
  return (
    <>
      <BrandHead />
      <ScrollToTop />
      {element}
    </>
  )
}

export default App
